import * as React from "react";

function SvgMovePlateToImager(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 34" fill="none" {...props}>
      <path
        d="M25.028 20.778a.472.472 0 100-.945.472.472 0 000 .945zM21.88 17.945a.394.394 0 11-.788 0 .394.394 0 01.787 0zM19.361 22.667a.472.472 0 100-.945.472.472 0 000 .945zM24.634 26.208a.787.787 0 11-1.574 0 .787.787 0 011.574 0zM19.125 26.602a.394.394 0 100-.787.394.394 0 000 .787z"
        fill="#414042"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.93 22.667a8.264 8.264 0 11-16.527 0 8.264 8.264 0 0116.528 0zm-3.541-2.361a2.361 2.361 0 11-4.722 0 2.361 2.361 0 014.722 0zm-4.722-2.362a1.18 1.18 0 11-2.362 0 1.18 1.18 0 012.362 0zm-1.89 4.25a1.417 1.417 0 11-2.833 0 1.417 1.417 0 012.834 0zm5.431 4.014a2.361 2.361 0 11-4.722 0 2.361 2.361 0 014.722 0zm-7.083 1.18a1.18 1.18 0 100-2.36 1.18 1.18 0 000 2.36z"
        fill="#414042"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.333 13.394c0-1.043 1.018-2.06 2.06-2.06H31.94c1.044 0 2.061 1.017 2.061 2.06v18.545C34 32.983 32.983 34 31.94 34H13.393c-1.043 0-2.06-1.017-2.06-2.06V13.393zm20.778 9.273a9.444 9.444 0 11-18.889 0 9.444 9.444 0 0118.89 0z"
        fill="#414042"
      />
      <path
        d="M2.833 0L0 2.833l4.25 4.25-2.833 2.834h8.5v-8.5L7.083 4.25 2.833 0z"
        fill="#414042"
      />
    </svg>
  );
}

export default SvgMovePlateToImager;
